import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { Customer } from '../models';

export interface SelectedCustomerState {
  selectedCustomer: Customer | null;
}

const initialState: SelectedCustomerState = {
  selectedCustomer: null,
};

export const SelectedCustomerStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    setSelectedCustomer(selectedCustomer: Customer | null): void {
      patchState(store, { selectedCustomer });
    },
  })),
);
